import React from "react";

import BaseApp from "@apps/base/BaseApp";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";

import {setConsumerHeader} from "@globals/utils/setConsumerHeader";

import {AccessRightFlags, CheckAccess} from "@components/CheckAccess";

import RegistrationApp from "./RegistrationApp";

setConsumerHeader();

const root = createRoot(document.getElementById("root")!);

root.render(
  <BrowserRouter>
    <BaseApp includeHeader={false}>
      <CheckAccess
        flag={AccessRightFlags.Unauthorized}
        redirectTo="/"
        saveUrl={false}
      >
        <RegistrationApp />
      </CheckAccess>
    </BaseApp>
  </BrowserRouter>
);
